//cardapio-online\libs\components\modal\src\lib\ui-modal\ui-modal.component.ts
import { ChangeDetectionStrategy, Component, HostListener, input, output } from '@angular/core';

@Component({
  selector: 'lib-ui-modal',
  templateUrl: './ui-modal.component.html',
  styleUrl: './ui-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiModalComponent {
  readonly open = input<boolean>(false);
  readonly title = input.required<string>();
  readonly description = input<string | null>(null);

 readonly confirmLabel = input<string>('Confirmar');
  readonly cancelLabel = input<string>('Cancelar');
  readonly confirmDisabled = input<boolean>(false);

  readonly size = input<'sm' | 'md' | 'lg'>('md');
  readonly tone = input<'default' | 'danger-soft'>('default');
  readonly closeOnBackdrop = input<boolean>(true);
  readonly closeOnEscape = input<boolean>(true);
 readonly showCloseButton = input<boolean>(true);
  readonly showFooter = input<boolean>(true);

readonly floatingImageSrc = input<string | null>(null);
readonly floatingImageAlt = input<string>('');
readonly floatingSlot = input<boolean>(false);

  readonly confirmRequested = output<void>();
  readonly cancelRequested = output<void>();
  readonly closed = output<void>();

  @HostListener('document:keydown.escape')
  protected onEscapeKey(): void {
    if (!this.open() || !this.closeOnEscape()) {
      return;
    }

    this.handleClose();
  }


  protected onBackdropClick(): void {
    if (!this.open() || !this.closeOnBackdrop()) {
      return;
    }

    this.handleClose();
  }

  protected onBackdropKeydown(event: Event): void {
    event.preventDefault();
    this.onBackdropClick();
  }
  protected onCancel(): void {
    this.cancelRequested.emit();
    this.handleClose(false);
  }

  protected onConfirm(): void {
    if (this.confirmDisabled()) {
      return;
    }

    this.confirmRequested.emit();
  }

  protected onCloseButtonClick(): void {
    this.handleClose();
  }

  private handleClose(emitCancel = true): void {
    if (emitCancel) {
      this.cancelRequested.emit();
    }

    this.closed.emit();
  }
}
